<script>
import $ from 'jquery';
import * as d3 from 'd3';
import origins from '@/data/origins';
import areas from '@/data/areas';
import Corner from '@/classes/origins/Corner';
import Dot from '@/classes/origins/Dot';
import originsArea from './origins-area';
import Section from '@/components/Section.vue';
import Wrapper from '@/components/Wrapper.vue';

export default {
    name: 'origins',
    components: {
        Wrapper,
        Section,
        originsArea
    },
    props: {},
    data() {
        let theAreas, cameras;
        theAreas = areas;
        cameras = [{
            x : 0.7,
            y : 1.0
        }, {
            x : 1.65,
            y : 1.45
        }];

        return {
            dots: [],
            status: 0,
            areas: theAreas,
            state: {
                currentArea: theAreas[0]
            },
            graphics: {
                buttons: [],
                cubeButton: null,
                svg: null,
                textLayer: null,
                cubeLayer: null,
                areaLayer: null,
                moleculeLayer: null,
                labelLayer: null,
                backLayer: null,
                frontLayer: null,
                score: null,
                buttonLabel: [],
                subOriginLabel: null,
                legendLayer : null,
                translate: {
                    x: 210,
                    y: 170
                },
                scale: 130,
                speed: 0.2,
                duration: 50,
                dotSize: 10,
                warning : null
            },
            corners: [],
            backPlanes: [],
            frontRibs: [],
            backRibs: [],
            camera: cameras,
            thisCamera: cameras[0],
            loop: null,
            multiply: 3.5,
            currentOrigin: origins[0],
            originLabels: ['Natural Sources', 'International', 'National', 'Urban', 'Street'],
            originLabelsPositions: [0, 0, 0, 0, 0],
            subOriginLabelsWidth: [126, 138, 130, 155, 260],
            subOriginLabels: ['Natural Sources', 'Industry', 'Traffic', 'Households', 'Secondary PM (Agri + Ind + Traffic)']
        };
    },
    computed: {
        currentArea() {
            return this.state.currentArea;
        },
        data() {
            return this.currentOrigin[this.currentArea.name];
        }
    },
    methods: {
        updateCurrentArea() {
            this.changeData();
            this.executeStatus(0);
        },
        changeData() {
            this.createData();
            this.projectDots();
            this.createDots();
            // this.graphics.score.text(currentOrigin[currentArea].total);
        },
        createData() {
            let startX, startY, x, y, row, offset;
            startX = 0.5;
            startY = 0.4;
            row = 20; // nr in a horizontal row
            offset = 0.05; // spacing between dots
            this.dots = [];
            // check if the counrty has data
            if (this.data.total > 0) {
                for (var i = 0, l = this.data.share.length; i < l; i++) { // loop through the 5 origins (street, urban, etc)
                    var origin = Math.round(this.data.share[i].total * this.multiply),
                        thisRows = Math.ceil(origin / row),
                        restant = origin % row,
                        xCounter = 0,
                        yCounter = 0;
                    for (var j = 0; j < this.data.share[i].share.length; j++) { // loop through the 4 sub-origins (industry, traffic, etc)
                        var originSub = Math.round(this.data.share[i].share[j] * this.multiply); // this determines the nr of dots (in this sub-sub set)
                        for (var k = 0, kl = originSub; k < kl; k++) {
                            y = yCounter * offset;
                            x = xCounter * offset;
                            yCounter++;
                            if (yCounter === thisRows) {
                                yCounter = 0;
                                xCounter++;
                                if (xCounter === restant) {
                                    thisRows--;
                                }
                            }

                            this.dots.push(
                                new Dot((startX - x), (startY - y), i, j, this.graphics.speed)
                            );
                        }
                    }
                    this.originLabelsPositions[i] = 1.96 * this.graphics.scale * (0.5 - startY);
                    startY -= y;
                    // break after a new sub-set
                    if (this.data.share[i] !== 0) {
                        startY -= 4 * offset;
                    }
                }
                this.setOriginLabels();
            }
        },
        setOriginLabels() {
            for (var i = 0; i < this.originLabelsPositions.length; i++) {
                d3.select('.origins-origin-label-' + i)
                    .attr('y', this.originLabelsPositions[i])
                    .text(this.originLabels[i] + ' (' + this.data.share[i].total + 'µg/m³ PM₂.₅)');
            }
        },
        executeStatus(transitionTime) {
            if (this.status === 0 || this.status === 3) {
                this.status = 0;
                this.setCamera(0);
                $('.origin-label').hide(400);
                this.graphics.svg.attr('class', '');
                this.play();
            } else if (this.status === 1) {
                this.stop();
                this.setCamera(1);
                $('.origin-label').show(400);
                this.putToGrid(transitionTime);
                this.graphics.svg.attr('class', '');
            } else if (this.status === 2) {
                this.stop();
                this.putToGrid(transitionTime);
                //editButtonLabel(['', 'Back', '']);
                this.graphics.svg.attr('class', 'origins-status-3');
            }
        },
        stop() {
            clearInterval(this.loop);
            this.loop = null;
        },
        play() {
            if (!this.loop) {
                this.loop = setInterval( () => {
                    this.projectDots();
                    this.placeDots(this.graphics.duration);
                }, 17);
            }
        },
        createDots() {
            let data, g;
            data = this.dots;
            this.graphics.moleculeLayer.selectAll('*').remove();
            g = this.graphics.moleculeLayer.selectAll('.dot').data(data).enter().append('g').attr('class', function(d) {
                return 'dot origins-origin-sub-' + d.originSub;
            }).attr('transform', function(dot){
                return 'translate(' + dot.projectedX + ',' + dot.projectedY + ') scale(' + dot.projectedZ + ')';
            }).on('mouseover', function () {
                //this.createSubOriginLabel(d.projectedX, d.projectedY, d.origin, d.originSub);
            }).on('mouseout', function () {
                //this.removeSubOriginLabel(this);
            });

            g.append('polygon').attr('points', '3,0 6,3 3,6 0,3');

        },
        projectDots() {
            for (let dot of this.dots) {
                this.moveDot(dot);
                this.writeProjectionValues(dot);
            }
        },
        putToGrid(transitionTime) {
            for (let dot of this.dots) {
                dot.x = dot.gridX;
                dot.y = dot.gridY;
                dot.z = dot.gridZ;
                this.writeProjectionValues(dot);
            }
            this.placeDots(transitionTime);
        },
        writeProjectionValues(element) {
            let x, y, z;
            x = element.x;
            y = element.y;
            z = element.z;
            element.pointX = this.projectX(x, y);
            element.pointZ = this.projectY(x, y) * Math.sin(this.thisCamera.y) + z * Math.cos(this.thisCamera.y);
            element.pointY = this.projectY(x, y) * Math.cos(this.thisCamera.y) - z * Math.sin(this.thisCamera.y);
            element.projectedX = this.graphics.translate.x + element.pointX * (element.pointZ + 2) * this.graphics.scale;
            element.projectedY = this.graphics.translate.y + element.pointY * (element.pointZ + 2) * this.graphics.scale;
            element.projectedZ = (element.pointZ + 2) / 1.5;
        },
        moveDot(dot) {
            this.limit(dot, 'x');
            this.limit(dot, 'y');
            this.limit(dot, 'z');
        },
        placeDots(transitionSpeed) {
            this.graphics.moleculeLayer
                .selectAll('.dot')
                .transition()
                .duration(transitionSpeed)
                .attr('transform', (dot) => {
                    return 'translate(' + dot.projectedX + ',' + dot.projectedY + ') scale(' + dot.projectedZ + ')';
                });
        },
        setCamera(i) {
            this.thisCamera = this.camera[i];
            this.updateModelCube();
            this.updateCube();
        },
        updateModelCube() {
            for (let corner of this.corners) {
                this.writeProjectionValues(corner);
            }
        },
        drawCube() {
            // create back origins-ribs
            this.graphics.backLayer.selectAll('*').remove();
            this.graphics.backLayer.selectAll('.origins-plane').data(this.backPlanes).enter().append('polygon').attr('points', (d, i) =>{
                return this.getPoints(this.backPlanes, i);
            }).attr('class', 'origins-plane');
            this.graphics.backLayer.selectAll('.origins-rib').data(this.backRibs).enter().append('polygon').attr('points', (d, i) => {
                return this.getPoints(this.backRibs, i);
            }).attr('class', 'origins-rib');
            // create front origins-planes
            this.graphics.frontLayer.selectAll('*').remove();
            this.graphics.frontLayer.selectAll('.origins-rib').data(this.frontRibs).enter().append('polygon').attr('points', (d, i) => {
                return this.getPoints(this.frontRibs, i);
            }).attr('class', 'origins-rib');
        },
        getPoints(target, i) {
            let nrs =[0,1,2,3];
            return nrs.map(n => {
                let axes = ['X', 'Y'];
                return axes.map(axis => {
                    return Math.round(this.corners[target[i][n]]['projected' + axis]);
                }).join(',');
            }).join(' ');
        },
        updateCube() {
            this.graphics.backLayer.selectAll('.origins-plane').transition().duration(400).attr('points', (d,i) =>{
                return this.getPoints(this.backPlanes, i);
            });
            this.graphics.backLayer.selectAll('.origins-rib').transition().duration(400).attr('points', (d,i) =>{
                return this.getPoints(this.backRibs, i);
            });
            this.graphics.frontLayer.selectAll('.origins-rib').transition().duration(400).attr('points', (d,i) =>{
                return this.getPoints(this.frontRibs, i);
            });
        },
        createCubeData() {
            let cube = [
                [-0.5, -0.5, -0.5],
                [-0.5, -0.5, 0.5],
                [0.5, -0.5, 0.5],
                [0.5, -0.5, -0.5],
                [-0.5, 0.5, -0.5],
                [-0.5, 0.5, 0.5],
                [0.5, 0.5, 0.5],
                [0.5, 0.5, -0.5]
            ];
            this.backPlanes = [
                [0, 1, 2, 3], [3, 0, 4, 7], [1, 0, 4, 5], [4, 5, 6, 7], [6, 7, 3, 2]
            ];
            this.backRibs = [
                [0, 1, 2, 3], [3, 0, 4, 7], [1, 0, 4, 5]
            ];
            this.frontRibs = [
                [4, 5, 6, 7], [1, 5, 6, 2], [6, 7, 3, 2]
            ];
            for (var i = 0, l = cube.length; i < l; i++) {
                this.corners.push(
                    new Corner(cube[i][0], cube[i][1], cube[i][2])
                );
            }
            this.updateModelCube();
        },
        limit(dot, direction) {
            var value = dot[direction] + dot['d' + direction];
            if (value < -0.5) {
                value = -0.5;
                dot['d' + direction] *= -1;
            } else if (value > 0.5) {
                value = 0.5;
                dot['d' + direction] *= -1;
            }
            dot[direction] = value;
        },
        projectX(x, y) {
            return x * Math.cos(this.thisCamera.x) - y * Math.sin(this.thisCamera.x);
        },
        projectY(x, y) {
            return x * Math.sin(this.thisCamera.x) + y * Math.cos(this.thisCamera.x);
        },
        createCanvas() {
            this.graphics.svg = d3.select(this.$refs.container).append('svg').attr('width', '100%').attr('height', '100%');
            this.drawLegend();
            this.graphics.cubeLayer = this.graphics.svg.append('g')
                .attr('transform', function() {
                    return 'translate(0, 60)';
                })
                .attr('class', 'cube-layer');
            this.graphics.backLayer = this.graphics.cubeLayer.append('g').attr('class', 'origins-rib-layer');
            this.graphics.moleculeLayer = this.graphics.cubeLayer.append('g').attr('class', 'dot-layer');
            this.graphics.frontLayer = this.graphics.cubeLayer.append('g').attr('class', 'origins-plane-layer');
            this.graphics.labelLayer = this.graphics.svg.append('g').attr('class', 'label-layer').attr('transform', function() {
                return 'translate(80, 92)';
            });
            this.graphics.subOriginLabel = this.graphics.svg.append('g').attr('class', 'origins-molecule-label');
            this.graphics.warning = this.graphics.svg.append('text').attr('class', 'bold-12').attr('x', 260).attr('y', 130);
            this.createCubeButton();
            this.createOriginLabels();
        },
        drawLegend() {
            this.graphics.legendLayer = this.graphics.svg.append('g').attr('transform', function() {
                return 'translate(380, 100)';
            }).attr('class', 'legend-layer');
            for (var i = 0, l = this.subOriginLabels.length; i < l; i++) {
                var subG = this.graphics.legendLayer.append('g').attr('transform', function() {
                    return 'translate(0, ' + (i * 24) + ')';
                });
                subG.append('polygon')
                    .attr('points', '3,0 6,3 3,6 0,3')
                    .attr('class', 'origins-origin-sub-' + i);
                subG.append('text')
                    .attr('class', 'regular-12')
                    .attr('x', 12)
                    .attr('y', 7)
                    .text('= ' + this.subOriginLabels[i]);
            }
        },
        createCubeButton(){
            this.graphics.cubeButton = this.graphics.cubeLayer.append('g').attr('transform', () => {
                return 'translate(370, 190)';
            }).attr('class', 'origins-button').on('click', () => {
                this.status++;
                this.executeStatus(600);
            });
            this.graphics.cubeButton.append('circle')
                .attr('cx', 28)
                .attr('cy', 28)
                .attr('r', 28)
                .attr('class', 'fill-blue button');
            this.graphics.cubeButton.append('path')
                .attr('d', 'M25.6,13.836h3.208V25.6h11.764v3.208H28.808v11.764H25.6V28.808H13.836V25.6H25.6V13.836z')
                .attr('fill', '#fff');
        },
        createOriginLabels() {
            for (var i = 0; i < this.originLabels.length; i++) {
                this.graphics.labelLayer.append('text')
                    .attr('class', 'bold-12 origin-label origins-origin-label-' + i)
                    .attr('x', 0)
                    .attr('y', 0);
            }
        },
        render() {
            this.createCanvas();
            this.createCubeData();
            this.drawCube();
            this.changeData();
            this.executeStatus(0);
        },
        init() {
            this.render();
        }
    },
    mounted(){
        this.init();
    },
    watch: {
        currentArea: {
            handler: function() {
                setTimeout(() => {
                    this.updateCurrentArea();
                });
            }
        },
    }
};
</script>


<template>
    <Section id="origins">
        <h1>
            Origins of air pollution
        </h1>
        <h2>
            <span>Where do air pollutants come from?</span>
        </h2>
        <div class="text-block">
            <h3>
                Pick your situation to see how much fine particulate matter (PM₂.₅)
                on average could be in the air you breathe where you live.
                This provides you with a simulation of what you may experience.
                Note that these are just general figures and do not give the
                actual situation.
            </h3>
        </div>

        <Wrapper>
        <div class="origins__areas">
            <origins-area
                v-for="(area, index) in areas"
                :key="index"
                :area="area"
                :state="state"/>
        </div>

        <div
            ref="container"
            class="section__graphic">

            <div class="text-elements">
                <div class="text-elements__ug">
                    <div class="text-elements__ug-number">
                        {{data.total}}
                    </div>
                    <div class="text-elements__ug-label">
                        µg/m³ PM₂.₅
                    </div>
                </div>
                <div class="text-elements__limit-values">
                    The EU limit value for PM₂.₅: <b>25 µg/m³ PM₂.₅</b><br>
                    WHO guidelines suggest:<b>10 µg/m³ PM₂.₅</b>
                </div>

                <div class="text-elements__button">
                    Click to show
                    more details about
                    the sources of pollution
                </div>
            </div>
        </div>
        </Wrapper>
    </Section>
</template>


<style lang="scss">
.section__graphic {
    position: relative;
    margin-bottom: 60px;
    padding-bottom: 0px!important;

    .text-elements {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        pointer-events: none;
        font-size: 12px;

        .text-elements__ug {
            background: #fff;
            border: 1px solid var(--blue);
            display: flex;
            align-items: center;
            height: 32px;
            position: absolute;
            left: 20px;

            .text-elements__ug-number {
                font-size: 18px;
                font-weight: 700;
                height: 100%;
                display: flex;
                align-items: center;
                border-right: 1px solid var(--blue);
                width: 56px;
                justify-content: center;
            }

            .text-elements__ug-label {
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0 12px;
                white-space: nowrap;
            }
        }

        .text-elements__button {
            position: absolute;
            left: 455px;
            top: 260px;
            width: 130px;
            font-weight: 700;
        }

        .text-elements__limit-values {
            background: #fff;
            border: 1px solid var(--blue);
            position: absolute;
            left: 186px;
            white-space: nowrap;
            padding: 8px 12px;
        }
    }

    .origins-plane {
        fill: var(--pink);
    }

    .origins-rib {
        stroke: white;
        stroke-width: 1px;
        fill: none;
    }

    .dot {
        fill: #004A7A;
        transition: all 0.2s ease;
    }

    .origins-text-rect {
        fill: #fff;
        stroke-width: 1px;
        stroke: #004A7A;
    }

    .origins-text-text-big {
        fill: #004A7A;
        font-size: 18px;
        font-weight: 700;
    }

    .origins-area-text {
        fill: #004A7A;
        font-size: 12px;
    }

    .origins-button {
        cursor: pointer;
    }

    .origins-button circle {
        fill:  #003867;
        transition: all 0.5s ease;
    }

    .origins-button:hover circle {
        fill:  #00B9ED;
    }

    .origins-button-label {
        fill: #fff;
        font-size: 54px;
        text-anchor: middle
    }

    .legend-layer {
        display: none;
    }

    .origins-status-3 .legend-layer {
        display: block;
    }

    .origins-status-3 .origins-origin-sub-0 {
        fill: #fff;
    }

    .origins-status-3 .origins-origin-sub-1 {
        fill: #D51067;
    }

    .origins-status-3 .origins-origin-sub-2 {
        fill: #00B9ED;
    }

    .origins-status-3 .origins-origin-sub-3 {
        fill: #d5e;
    }

    .origins-status-3 .origins-origin-sub-4 {
        fill: #004A7A;
    }

    .origins-molecule-label rect {
        fill: #029087;
        stroke: #fff;
        stroke-width: 1px;
    }

    .origins-molecule-label text {
        fill: #fff;
        font-size: 10px;
    }
}

.origins__areas {
    display: flex;
    padding-left: 20px;
}
</style>
